import React, { Component, createRef } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import IconRefresh from '../../assets/icons/IconRefresh';
import IconSearch from '../../assets/icons/IconSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class SearchbarMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            keyword: '',
            searchBy: {
                data: [],
                value: ''
            },
            showSearchByModal: false,
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.handleSearch(this.state.keyword);
    }

    handleChangeSearchBy = data => {
        this.setState({
            searchBy: {
                ...this.state.searchBy,
                value: data
            }
        })
    }

    handleResetGeneralSearch = () => {
        if (window.location.pathname.includes(ROUTER_CONSTANT.CONTACT)) {
            this.setState({
                keyword: '',
                searchBy: {
                    ...this.state.searchBy,
                    value: {
                        label: 'Nama Distributor',
                        value: 'user_nexcare.alias_name'
                    }
                }
            })
        } else {
            this.setState({
                keyword: '',
                searchBy: {
                    ...this.state.searchBy,
                    value: {
                        label: 'Nomor Tiket',
                        value: 'ticket.ticket_no'
                    }
                }
            })
        }
    }

    handleSubmitGeneralSearch = e => {
        e.preventDefault();
        this.props.handleSearch(this.state.searchBy.value.value, this.state.keyword);
    }

    handleDropdown = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target)) {
            this.setState({
                showSearchByModal: false
            })
        }
    }

    componentDidMount() {
        this.dropdownRef = createRef()

        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)
            || window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)
            || window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER)) {

            if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)
                && this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
                return this.setState({
                    searchBy: {
                        data: [
                            {
                                label: 'Nomor Tiket',
                                value: 'ticket.ticket_no'
                            },
                            {
                                label: 'Judul Keluhan',
                                value: 'ticket.issue_title'
                            },
                            {
                                label: 'Deskripsi Keluhan',
                                value: 'ticket.issue_desc'
                            },
                            {
                                label: 'Nama Distributor',
                                value: 'customer.alias_name'
                            }
                        ],
                        value: {
                            label: 'Nomor Tiket',
                            value: 'ticket.ticket_no'
                        }
                    }
                })
            }

            this.setState({
                searchBy: {
                    data: [
                        {
                            label: 'Nomor Tiket',
                            value: 'ticket.ticket_no'
                        },
                        {
                            label: 'Judul Keluhan',
                            value: 'ticket.issue_title'
                        },
                        {
                            label: 'Deskripsi Keluhan',
                            value: 'ticket.issue_desc'
                        },
                        {
                            label: 'Nama Distributor',
                            value: 'customer.alias_name'
                        },
                        {
                            label: 'Nomor Bug',
                            value: 'ticket.no_redmine'
                        }
                    ],
                    value: {
                        label: 'Nomor Tiket',
                        value: 'ticket.ticket_no'
                    }
                }
            })
        }

        if (window.location.pathname.includes(ROUTER_CONSTANT.CONTACT)) {
            this.setState({
                searchBy: {
                    data: [
                        {
                            label: 'Nama Distributor',
                            value: 'user_nexcare.alias_name'
                        },
                        {
                            label: 'Nama PIC',
                            value: 'user_contact.pic_name'
                        },
                        {
                            label: 'Nomor Telepon PIC',
                            value: 'user_contact.pic_phone'
                        }
                    ],
                    value: {
                        label: 'Nama Distributor',
                        value: 'user_nexcare.alias_name'
                    }
                }
            })
        }

        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            this.setState({
                searchBy: {
                    data: [
                        {
                            label: 'Nomor Tiket',
                            value: 'ticket.ticket_no'
                        },
                        {
                            label: 'Judul Keluhan',
                            value: 'ticket.issue_title'
                        },
                        {
                            label: 'Deskripsi Keluhan',
                            value: 'ticket.issue_desc'
                        },
                        {
                            label: 'Nama Distributor',
                            value: 'customer.alias_name'
                        },
                        {
                            label: 'Solusi',
                            value: 'ticket.solution'
                        },
                        {
                            label: 'Nomor Bug',
                            value: 'ticket.no_redmine'
                        }
                    ],
                    value: {
                        label: 'Nomor Tiket',
                        value: 'ticket.ticket_no'
                    }
                }
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showSearchByModal !== this.state.showSearchByModal) {
            if (this.state.showSearchByModal) {
                document.addEventListener('click', this.handleDropdown)
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDropdown)
    }

    render() {
        return (
            <>
                {
                    (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)
                        || window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)
                        || window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER)
                        || window.location.pathname.includes(ROUTER_CONSTANT.CONTACT)
                        || window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION))
                        ? <form onSubmit={this.handleSubmitGeneralSearch} className="flex items-center w-3/5 mb-10">
                            <div className="searchbar flex items-center rounded-full bg-white px-5 w-1/2 mr-2 h-11">
                                <div className="mr-5">
                                    <IconSearch />
                                </div>
                                <input
                                    type="text"
                                    id="tslsearch"
                                    value={this.state.keyword}
                                    name="keyword"
                                    placeholder={this.props.placeholder === undefined ? "Pencarian" : this.props.placeholder}
                                    className="outline-none font-medium placeholder-gray-300 w-full text-gray-600"
                                    autoComplete="off"
                                    onChange={this.handleChange}
                                />
                            </div>
                            <button type="button" id="btnsearchby" className="bg-white text-darkblue text-sm font-bold flex justify-between items-center rounded-full focus:outline-none w-40 px-3 mx-1 h-11" onClick={() => this.setState({ showSearchByModal: !this.state.showSearchByModal })} ref={this.dropdownRef}>
                                <p>{this.state.searchBy.value.label}</p>
                                <FontAwesomeIcon icon={faChevronDown} />
                            </button>
                            <div className={this.state.showSearchByModal ? "relative" : "hidden"}>
                                <div className="origin-top-right absolute right-0 mt-7 z-10 w-60 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none text-gray-600">
                                    {
                                        this.state.searchBy.data.map((data, idx) =>
                                            <div className="pt-3 pl-3 pr-3 hover:bg-blue-100 cursor-pointer" key={idx} id="btnselectsearchby" onClick={() => this.handleChangeSearchBy(data)}>
                                                {
                                                    this.state.searchBy.data.length === idx + 1
                                                        ? <p className="pb-3 text-sm">{data.label}</p>
                                                        : <p className="pb-3 border-b-2 border-gray text-sm">{data.label}</p>
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="flex">
                                <button type="button" id="btnreset" className="bg-darkblue text-white text-sm rounded px-3 mx-1 h-10" onClick={() => this.handleResetGeneralSearch()}>Atur Ulang</button>
                                <button type="submit" id="btnsearch" className="bg-lightblue text-white text-sm rounded px-3 mx-1 h-10">Cari</button>
                                <div className="bg-lightblue rounded text-white flex justify-center items-center cursor-pointer px-3 mx-1 h-10" onClick={(e) => this.handleSubmitGeneralSearch(e)}>
                                    <IconRefresh />
                                </div>
                            </div>
                        </form>
                        :
                        <form onSubmit={this.handleSubmit} className="flex items-center w-3/5 mb-10">
                            <div className="searchbar flex rounded-full bg-white py-2 px-5 w-1/2 mr-2">
                                <div className="mr-5">
                                    <IconSearch />
                                </div>
                                <input
                                    type="text"
                                    id="tslsearch"
                                    name="keyword"
                                    placeholder={this.props.placeholder === undefined ? "Pencarian" : this.props.placeholder}
                                    className="outline-none font-medium placeholder-gray-300 w-full text-gray-600"
                                    autoComplete="off"
                                    onChange={this.handleChange}
                                />
                                <button type="submit" id="btnsearch" className="hidden"></button>
                            </div>
                        </form>
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default withRouter(connect(mapStateToProps, null)(SearchbarMenu));